/* Chocolat floating-widget rail.
   Google renders its badge inside a cross-origin iframe. We therefore resize
   only the closed 84 px launcher; the expanded panel remains unscaled. */
(function () {
  var SELECTOR = '#google-merchantwidget-iframe-wrapper';
  var widgetObserver = null;
  var resizeObserver = null;

  function pinCollapsedWidget(widget) {
    var mobile = window.matchMedia('(max-width: 767px)').matches;
    var left = mobile ? '14px' : '20px';
    var bottom = mobile ? '52px' : '54px';

    if (widget.style.getPropertyValue('left') !== left ||
        widget.style.getPropertyPriority('left') !== 'important') {
      widget.style.setProperty('left', left, 'important');
    }
    if (widget.style.getPropertyValue('bottom') !== bottom ||
        widget.style.getPropertyPriority('bottom') !== 'important') {
      widget.style.setProperty('bottom', bottom, 'important');
    }
  }

  function syncWidgetState(widget) {
    var width = parseFloat(widget.style.width) || widget.offsetWidth;
    var height = parseFloat(widget.style.height) || widget.offsetHeight;
    var state = width <= 100 && height <= 100 ? 'collapsed' : 'expanded';

    if (widget.getAttribute('data-lakis-widget-state') !== state) {
      widget.setAttribute('data-lakis-widget-state', state);
    }
    if (state === 'collapsed') pinCollapsedWidget(widget);
  }

  function connect(widget) {
    if (!widget || widget.getAttribute('data-lakis-widget-connected') === 'true') return;

    widget.setAttribute('data-lakis-widget-connected', 'true');
    syncWidgetState(widget);

    widgetObserver = new MutationObserver(function () {
      syncWidgetState(widget);
    });
    widgetObserver.observe(widget, {
      attributes: true,
      attributeFilter: ['style']
    });

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function () {
        syncWidgetState(widget);
      });
      resizeObserver.observe(widget);
    }

    window.addEventListener('resize', function () {
      syncWidgetState(widget);
    }, { passive: true });
  }

  function findWidget() {
    var widget = document.querySelector(SELECTOR);
    if (widget) connect(widget);
    return Boolean(widget);
  }

  if (!findWidget()) {
    var documentObserver = new MutationObserver(function () {
      if (findWidget()) documentObserver.disconnect();
    });
    documentObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();

/* --- view_cart-Ereignis (02.08.2026) -------------------------------------
   Befund: In GA4 feuerte view_cart NULL Mal. Damit war ausgerechnet der Schritt
   unsichtbar, an dem der Trichter bricht — 139 add_to_cart gegen 16
   begin_checkout (11,5 %; üblich 40–60 %). Ohne dieses Ereignis lässt sich
   weder die Ursache eingrenzen noch die Wirkung einer Änderung belegen.

   Weg: dataLayer → GTM → GA4. Das ist im Shop nachweislich funktionsfähig —
   b2b_brief_complete aus lakis-firmengeschenke.liquid kommt so in GA4 an.
   Hier angehängt statt als eigene Datei, weil lakis-floating-widgets.js
   bereits auf jeder Seite geladen wird: keine zusätzliche Einbindung in
   theme.liquid, die ein Krown-Update zurücksetzen könnte.

   Der Warenkorb ist ein Overlay ohne Seitenwechsel; es gibt also kein
   Seitenaufruf-Ereignis, an das man sich hängen könnte. Beobachtet wird
   deshalb der Klassenwechsel auf sidebar--opened (section-header.js). */
(function () {
  var drawer = document.getElementById('site-cart-sidebar');
  if (!drawer || !window.MutationObserver) return;

  var warOffen = drawer.classList.contains('sidebar--opened');

  function warenkorbInhalt(callback) {
    // Preis und Positionen aus Shopifys Cart-API — der Overlay-DOM ist beim
    // Öffnen noch nicht zuverlässig befüllt.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(callback)
      .catch(function () { callback(null); });
  }

  function melde() {
    warenkorbInhalt(function (cart) {
      window.dataLayer = window.dataLayer || [];
      var nutzlast = { event: 'view_cart' };
      if (cart) {
        nutzlast.currency = cart.currency;
        nutzlast.value = cart.total_price / 100;
        nutzlast.items = (cart.items || []).map(function (i) {
          return {
            item_id: String(i.product_id),
            item_name: i.product_title,
            item_variant: i.variant_title || undefined,
            price: i.final_price / 100,
            quantity: i.quantity
          };
        });
      }
      window.dataLayer.push(nutzlast);
    });
  }

  new MutationObserver(function () {
    var offen = drawer.classList.contains('sidebar--opened');
    // Nur die Flanke zu, dann auf — sonst meldet jede Mengenänderung im
    // offenen Warenkorb ein weiteres view_cart.
    if (offen && !warOffen) melde();
    warOffen = offen;
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
})();
